/**
 * React Query client configuration
 * Optimized for real-time updates and caching
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache for 5 minutes before marking as stale
      staleTime: 1000 * 60 * 5,

      // Refetch every 1 minute for real-time updates
      refetchInterval: 1000 * 60,

      // Don't refetch on window focus (rely on interval instead)
      refetchOnWindowFocus: false,

      // Retry failed requests up to 3 times with exponential backoff
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

      // Keep data in cache for 10 minutes after last use
      gcTime: 1000 * 60 * 10,
    },
    mutations: {
      // Retry mutations once on failure
      retry: 1,

      // Don't refetch queries on mutation error
      onError: () => {
        // Error handling in individual mutation hooks
      },
    },
  },
});

export default queryClient;
